import React from 'react';
import { FieldProps } from 'react-final-form';
import DropZone from 'components/dropzone/DropZone';

interface DropZoneInputProps extends FieldProps {
  name: string;
  message: string;
  imageContentBase64?: string;
  imageFileType?: string;
  isImage?: boolean;
}

export const dropzoneInput = (fields: FieldProps): DropZoneInputProps => {
  return {
    name: fields.name,
    render: (props) => (
        <DropZone
            maxSize={524288}
            message={fields.message}
            imageContentBase64={fields.imageContentBase64}
            imageFileType={fields.imageFileType}
            isImage={fields.isImage}
            onDropAccepted={acceptedFiles => props.input.onChange(acceptedFiles[0])}
            onDropRejected={console.log}
            {...props.input}
        />
    ),
    message: fields.message,
    ...fields
  }
};
